import React from 'react';
import {
  Calendar,
  HeaderProps,
  momentLocalizer,
  ToolbarProps
} from 'react-big-calendar';
import type { CalendarProps } from 'react-big-calendar';
import { Space } from 'antd';
import moment from 'moment';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Button from '../Button';
import styled from '@emotion/styled';
const WrapperHeader = styled.div`
  height: 65px;
  display: flex;
  algin-items: center;
  > span {
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0.005em;
    text-align: left;
    color: rgba(35, 43, 58, 1);
  }
`;
const StyledToolbar = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  align-content: stretch;
  height: 65px;
`;
/**
 *
 * @param props
 * localizer : moment } date-fns | globalize default this project using moment.
 * @returns
 */
const Scheduler = (
  props: Partial<CalendarProps> & {
    className?: any;
  }
) => {
  const { className, ...rest } = props;
  return (
    <Calendar
      defaultView={props.defaultView}
      className={className}
      components={props.components}
      localizer={momentLocalizer(moment)}
      startAccessor="start"
      endAccessor="end"
      {...rest}
    ></Calendar>
  );
};

const Toolbar = (
  props: Partial<ToolbarProps> & {
    leftElement?: React.ReactNode;
    rightElement?: React.ReactNode;
  }
) => {
  return (
    <StyledToolbar>
      <div>{props.leftElement}</div>
      <Space size={16}>
        <Button
          type="text"
          onClick={() => {
            if (props.onNavigate) {
              props?.onNavigate('PREV');
            }
          }}
          icon={<LeftOutlined></LeftOutlined>}
        ></Button>
        <Button type="link">
          {(props.localizer as any).format(props.date, 'DD MMMM YYYY')}
        </Button>
        <Button
          type="text"
          onClick={() => {
            if (props.onNavigate) {
              props?.onNavigate('NEXT');
            }
          }}
          icon={<RightOutlined></RightOutlined>}
        ></Button>
      </Space>
      <div>{props.rightElement}</div>
    </StyledToolbar>
  );
};

const HeaderWeek = (props: Partial<HeaderProps>) => {
  return (
    <WrapperHeader>
      <span>{props.localizer?.format((props as any)?.date, 'D ddd')}</span>
    </WrapperHeader>
  );
};
Scheduler.Toolbar = Toolbar;
Scheduler.HeaderWeek = HeaderWeek;
export default Scheduler;
